/* eslint-disable no-undef */
import React from 'react';
import { Styles } from './styles';
import { IPropertyCharacteristic } from '@stores/Property/types';

interface FeaturesListProps {
  features: IPropertyCharacteristic[];
}

const FeaturesList: React.FC<FeaturesListProps> = ({ features }) => {
  return (
    <Styles.FeatureBox2>
      {/* Título permanece externo ao card */}
      <Styles.TopHeading>Características</Styles.TopHeading>

      {/* Card da listagem em grade com rolagem interna */}
      <Styles.FeaturesContainer role="list">
        {features.map((feature, index) => (
          <Styles.FeatureBox key={index} role="listitem" title={feature.titulo}>
            <Styles.FeatureText>{feature.titulo}</Styles.FeatureText>
          </Styles.FeatureBox>
        ))}
      </Styles.FeaturesContainer>
    </Styles.FeatureBox2>
  );
};

export default FeaturesList;
